export class ErrorDetails {
    errorMessage: string;
    displayError = false;
     errorDialogHeader: string;
}
